export default [
  {
    link: 'dashboard',
    label: '待处理事项',
    visible:true,
    hideIcyDesign: true,
    tabId:0,
    icon: 'fa-tachometer'
  },

  {
    label: 'i.CY',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    tabId:41,
    oldLink: true,
    subMenu: [
      {
        link: '/adminv/#!/icy/inventorySales',
        label: '库存销售分布'
      }
    ]
  },

  {
    label: '视频管理',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    tabId:41,
    oldLink: true,
    subMenu: [
      {
        link: '/adminv/#!/videoUploader',
        label: '视频上传'
      }
    ]
  },
  {
    label: '客服',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    tabId:40,
    subMenu: [
      {
        link: 'csStatistics',
        label: '客服工作统计'
      },
      {
        link: 'icyChatConf',
        label: 'ICY对话配置'
      },
    ]
  },

  {
    label: '自主商品',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    tabId:40,
    subMenu: [
      {
        link: 'showTimeLimit',
        label: '限时折扣'
      }
    ]
  },

  {
    label: '活动',
    icon: 'fa-bar-chart',
    expanded: false,
    visible:false,
    tabId:40,
    subMenu: [
      {
        link: 'showTimeLimitPrice',
        label: '限时改价'
      },

      {
          link: 'definitionSummer',
          label: 'ICY定义你的夏天'
      }
    ]
  },
  {
    label: 'ICY-系统设置',
    link: 'icySysSetting',
    icon: 'fa-cog',
    visible:true,
    tabId: 40,
  },
  {
    label: '小程序环境设置',
    link: 'wxAppSwitch',
    icon: 'fa-cog',
    visible:true,
    tabId: 40,
  },
  {
  	label: '推送',
  	icon: 'fa-cog',
  	expanded: false,
  	visible: false,
  	tabId: 11,
  	subMenu: [
  	  {
  		link: 'icyPush',
  		label: 'ICY活动推送'
  	  },
  	]
  },
]
